import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿El libro es físico?',
  a: 'No. Es un eBook digital (PDF) que recibes al instante en tu correo. Puedes leerlo en tu celular, tablet o computador mientras cocinas.'
}, {
  q: '¿Sirve para cualquier marca de Airfryer?',
  a: 'Sí. Incluye una tabla de ajustes para marcas comunes en Colombia (Imusa, Oster, Philips, etc.) y una guía rápida para calibrar la tuya si es de otra marca.'
}, {
  q: '¿Los ingredientes son caros?',
  a: 'No. Está pensado para ingredientes que consigues en el D1, Ara, tienda de barrio o plaza de mercado. Comida real, presupuesto real.'
}, {
  q: '¿Cómo lo pago? ¿Es seguro?',
  a: 'Pago 100% seguro por pasarela encriptada. Aceptamos tarjetas de crédito, débito, PSE y métodos locales como Nequi.'
}, {
  q: '¿Esto garantiza que me quede perfecto siempre?',
  a: 'No podemos prometer resultados mágicos sin esfuerzo, pero sí te damos el método exacto, los tiempos y las correcciones para que mejores rápido y logres repetir el éxito.'
}, {
  q: '¿Tengo garantía?',
  a: 'Sí: tienes 7 días de garantía de satisfacción. Si no te sirve, te devolvemos el dinero.'
}, {
  q: '¿Es una suscripción?',
  a: 'No. Es un pago único de $23.999 COP. Pagas una vez y tienes acceso de por vida al eBook y al bono.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-warm-50" data-id="element-48">
      <div className="max-w-3xl mx-auto px-4" data-id="element-49">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-charcoal mb-12" data-id="element-50">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-51">
          {FAQS.map((faq, index) => <div key={index} className="bg-white border border-warm-200 rounded-xl overflow-hidden shadow-sm transition-all duration-200" data-id="element-52">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-53">
                <span className="font-bold text-charcoal pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-primary transition-transform duration-200 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-56">
                <p className="text-charcoal-muted" data-id="element-57">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}